import moment from 'moment';
import { getTeamUrl } from 'Common';

export default (options) => async (dispatch, getState) => {

  const type = options.key;

  const { sorting, searchTerm, filters } = getState().screens.Orders;

  const params = {};

  if (sorting.columnKey) {
    params.csort = (sorting.order === 'descend' ? '-' : '') + sorting.columnKey;
  }

  if (searchTerm) {
    params.search = searchTerm;
  }

  if (filters.quick_filter !== 'all' && filters.quick_filter !== undefined) {
    params['filter[quick_filter]'] = filters.quick_filter;
  }

  if (filters.client_id > 0) {
    params['filter[client_id]'] = filters.client_id;
  }

  if (filters.extra_works !== 'all') {
    params['filter[extra_works]'] = filters.extra_works;
  }

  if (Array.isArray(filters.date_between) && filters.date_between.length === 2) {
    params['filter[date_between]'] = filters.date_between.map(date => moment(date).format('YYYY-MM-DD')).join();
  }

  if (filters.po_loaded !== 'all') {
    params['filter[po_loaded]'] = filters.po_loaded;
  }

  if (filters.sent_to_subcontractor !== 'all') {
    params['filter[sent_to_subcontractor]'] = filters.sent_to_subcontractor;
  }

  if (filters.procurement_only !== 'all') {
    params['filter[procurement_only]'] = filters.procurement_only;
  }

  let url = `orders/export?type=${type}`;

  Object.keys(params).forEach(key => {
    url += `&${key}=${params[key]}`
  })

  window.location = getTeamUrl(url, 'exports');

}
